import { GetCodeListResponse } from 'src/app/commons/kymw02/api-services/get-code-list.service';
import { KYMW7201Component } from './kymw7201.component';

/**
 * 運営商品登録画面の値を管理するクラス
 *
 * @export KYMW7201Model
 * @class KYMW7201Model
 */
export class KYMW7201Model {

  kymw7201Component: KYMW7201Component;

  /** 運営商品ID */
  public operationGoodsId: string = <string>'';
  /** 運営商品ステータス */
  public operationGoodsStatus: string = <string>'';
  /** 宅配業態 */
  public deliveryDiv: string = <string>'1';
  /** 注文コード */
  public orderNum: string = <string>'';
  /** 利用都県 */
  public coopCodeList: Array<any> = new Array<any>();
  /** 利用生協 */
  public allSeikyou = Boolean(false);
  public ibaraki = Boolean(false);
  public tochigi = Boolean(false);
  public gunma = Boolean(false);
  public chiba = Boolean(false);
  public saitama = Boolean(false);
  public tokyo = Boolean(false);
  public nagano = Boolean(false);
  public niigata = Boolean(false);
  /** 運営企画区分 */
  public planningManagementDiv: string = <string>'';
  /** 運営企画詳細区分 */
  public planningManagementDetailDiv: string = <string>'';
  /** 受注受付開始企画回 */
  public orderReceptionStartCatalog: string = <string>'';
  /** 受注受付終了企画回 */
  public orderReceptionEndCatalog: string = <string>'';
  /** 積立増資パターン */
  public depositCapitalIncreasePattern: string = <string>'';
  /** 積立増資回数 */
  public depositCapitalIncreaseCount: string = <string>'';
  /** 単価 */
  public unitPrice: string = <string>'';
  /** 帳票チラシコード */
  public formFlyerCode: string = <string>'';
  /** ポイント数 */
  public pointNumber: string = <string>'';
  /** 休止グループコード */
  public pauseGroupCode: string = <string>'';
  /** PD区分 */
  public pdDiv: string = <string>'';
  /** 配達リード区分 */
  public deliveryLeadDiv: string = <string>'';
  /** 商品名 */
  public goodsName: string = <string>'';
  /** 商品名カナ */
  public goodsNameKana: string = <string>'';
  /** 規格名 */
  public standardName: string = <string>'';
  /** 規格名カナ */
  public standardNameKana: string = <string>'';
  /** 計上部門 */
  public appropriatingClass: string = <string>'';
  /** 消費税区分 */
  public consumeTaxDiv: string = <string>'';
  /** 消費税率 */
  public consumeTaxRate: string = <string>'';
  /** 表示非表示フラグ */
  public btnApprovalDisplay: boolean = <boolean>false;
  public btnRegistDisplay: boolean = <boolean>false;
  /** 活性非活性フラグ */
  public btnApprovalEnabled: boolean = <boolean>false;
  public btnRegistEnabled: boolean = <boolean>false;

  public setReserveNum1: string = <string>'';
  public setCodeDiv: string = <string>"";
  /** 区分リスト */
  public arrangeDivList: GetCodeListResponse = [];

  /** 運営商品一覧画面の検索条件を保持するためのパラメータ */
  public searchDeliveryDiv: string = <string>'';
  public searchOrderNum: string = <string>'';
  public searchPlanningManagementDiv: string = <string>'';
  public searchGoodsName: string = <string>'';
  public searchOrderCatalog: string = <string>'';
  public searchPlanningManagementDetailDiv: string = <string>'';
  public searchStandardName: string = <string>'';

  public commitData(serverData: any): void {
    this.operationGoodsId = serverData.OperationGoodsId;
    this.operationGoodsStatus = serverData.OperationGoodsStatus;
    this.deliveryDiv = serverData.DeliveryDiv;
    this.orderNum = serverData.OrderNum;
    this.coopCodeList = serverData.CoopCodeList;
    this.coopCodeList.forEach(item => {
      if (item === this.kymw7201Component.coopMap.get(this.kymw7201Component.COOP_CODE_IBARAKI)) {
        this.ibaraki = true;
      } else if (item === this.kymw7201Component.coopMap.get(this.kymw7201Component.COOP_CODE_TOCHIGI)) {
        this.tochigi = true;
      } else if (item === this.kymw7201Component.coopMap.get(this.kymw7201Component.COOP_CODE_GUNNMA)) {
        this.gunma = true;
      } else if (item === this.kymw7201Component.coopMap.get(this.kymw7201Component.COOP_CODE_CHIBA)) {
        this.chiba = true;
      } else if (item === this.kymw7201Component.coopMap.get(this.kymw7201Component.COOP_CODE_SAITAMA)) {
        this.saitama = true;
      } else if (item === this.kymw7201Component.coopMap.get(this.kymw7201Component.COOP_CODE_TOKYO)) {
        this.tokyo = true;
      } else if (item === this.kymw7201Component.coopMap.get(this.kymw7201Component.COOP_CODE_NAGANO)) {
        this.nagano = true;
      } else if (item === this.kymw7201Component.coopMap.get(this.kymw7201Component.COOP_CODE_NIIGATA)) {
        this.niigata = true;
      }
    });
    if (this.ibaraki && this.tochigi && this.gunma && this.chiba && this.saitama && this.tokyo && this.nagano && this.niigata) {
      this.allSeikyou = true;
    }
    this.planningManagementDiv = serverData.PlanningManagementDiv;
    this.planningManagementDetailDiv = serverData.PlanningManagementDetailDiv;
    this.orderReceptionStartCatalog = serverData.OrderReceptionStartCatalog;
    this.orderReceptionEndCatalog = serverData.OrderReceptionEndCatalog;
    this.depositCapitalIncreasePattern = serverData.DepositCapitalIncreasePattern;
    this.depositCapitalIncreaseCount = serverData.DepositCapitalIncreaseCount;
    this.unitPrice = serverData.UnitPrice;
    this.formFlyerCode = serverData.FormFlyerCode;
    this.pointNumber = serverData.PointNumber;
    this.pauseGroupCode = serverData.PauseGroupCode;
    this.pdDiv = serverData.PdDiv;
    this.deliveryLeadDiv = serverData.DeliveryLeadDiv;
    this.goodsName = serverData.GoodsName;
    this.goodsNameKana = serverData.GoodsNameKana;
    this.standardName = serverData.StandardName;
    this.standardNameKana = serverData.StandardNameKana;
    this.appropriatingClass = serverData.AppropriatingClass;
    this.consumeTaxDiv = serverData.ConsumeTaxDiv;
    this.consumeTaxRate = serverData.ConsumeTaxRate;
  }
}
